'use strict';

var app = angular.module('atex.dam');
    app.filter('trustAsHTML',['$filter', '$sce', 
                       function($filter, $sce) {
                           return function(text, target, type) {
                           if (!text) {
                             return text;
                           }
                       var replacedText = text; // $filter('linky')(text, target); DO NOT USE linky to avoid issues with highlight
                       var targetAttr = "";
                       if (angular.isDefined(target)) {
                           targetAttr = ' target="' + target + '"';
                       }else{
                           targetAttr = ' target="_blank"';
                       }
                       var _text = text;
                       if(text instanceof Object) {
                         _text = text.text;
                       }
                       var replacePattern = /(^|\s)http(s?):\/\/(\w*[^ ]+\w*)/gim;
                       replacedText = _text.replace(replacePattern, '$1<a href="http$2://$3"' + targetAttr + '>http$2://$3</a>');
                       
                       /*
                        * not used at the moment, here for possible future implementation
                        */
                       if(type === 'twitter'){
                           // replace #hashtags and send them to twitter
                           replacePattern = /(^|\s)#(\w*[a-zA-Z_]+\w*)/gim;
                           replacedText = _text.replace(replacePattern, '$1<a class="hashtag" href="https://twitter.com/search?q=%23$2"' + targetAttr + '>#$2</a>');
                           // replace @mentions but keep them to our site
                           replacePattern = /(^|\s)\@(\w*[a-zA-Z_]+\w*)/gim;
                           replacedText = replacedText.replace(replacePattern, '$1<a class="hashtag" href="https://twitter.com/$2"' + targetAttr + '>@$2</a>');
                       } else if(type === 'facebook'){
                           // replace #hashtags and send them to facebook
                           replacePattern = /(^|\s)#(\w*[a-zA-Z_]+\w*)/gim;
                           replacedText = _text.replace(replacePattern, '$1<a class="hashtag" href="https://facebook.com/hashtag/$2"' + targetAttr + '>#$2</a>');
                       }

                       return $sce.trustAsHtml(replacedText);
                   };
    }]);
